import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import ReactPlayer from 'react-player'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import config from '../../config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  SocialButtons,
  SignupForm,
  AboutBanner,
  GetStartedInput
} from '../../components'
import Styles from './Toolkit.css'


@CSSModules(Styles, {allowMultiple:true})
export default class Toolkit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: 'Dear Plan Administrator,\nI am an employee of [Company Name], and I participate in our company 401(k) plan. I am writing to raise concerns about tropical deforestation and human rights abuses that may be supported by our current investment policy and about my desire to have options for socially responsible funds.\nDeforestation is a major driver of climate change, biodiversity loss, and attacks on indigenous communities across the tropics. Conversely, maintaining healthy, intact ecosystems is the best prevention we have against both runaway climate change and future pandemics. As the environmental and social effects of deforestation become more widely recognized, investments in the agribusiness companies behind the problem are becoming increasingly risky.\nI [and the attached list of employees] would like to be able to invest in a fund that does not harm forests for purposes of agro-commodity production or sales. Through use of an online tool at deforestationfreefunds.org I was able to analyze many commonly available mutual funds and identify ones that earn a top score regarding deforestation. Importantly, this tool also provides information on funds that are also socially responsible. I note that none of the funds offered in our 401(k) fund are currently forest-safe and socially responsible. In addition to being deforestation-free, I [we] seek a fund that is socially responsible. Socially responsible investing is no longer just an ethical issue, it is a key factor in reducing investment risk and impacting financial well-being. New guidelines from the Department of Labor state that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be used when making decisions related to fiduciary duty.\nSince none of our current plan options are both socially responsible and earn a top rating as deforestation-free, I request that our 401(k) fund plan begin offering one or more such funds in which interested employees can invest. The deforestationfreefunds.org tool is a good option for finding suitable mutual funds that could be included in our plan.\nThank you in advance for looking into this. I appreciate your time and look forward to hearing from you.\nBest,\n[Your Name]\n[Your contact information (company department, email, phone)]\n[Attachment: Employee/manager letter of support]',
      copied: false,
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  onCopy = () => {
    this.setState({copied: true})
  }

  render() {
    const title = '#DefundDeforestation Toolkit'
    const description = 'A How-To Guide to Deforestation Free 401(k)s'
    const url = config.domain + config.routes.toolkit

    const bannerImage = 'green'
    const bannerHeadline = '#DefundDeforestation Toolkit'
    const bannerSubtitle = 'A How-To Guide to Deforestation Free 401(k)s'

    const infographicLarge = require('../../../static/images/large-palm-oil-infographic.jpg')
    const infographicSmall = require('../../../static/images/small-palm-oil-infographic.jpg')

    const message = '#DefundDeforestation Toolkit: A How-To Guide to Deforestation Free 401(k)s'

    return <div>
      {container.helmet(title, description, url)}

      <ContainerDivs>
        <h1 styleName='title'>
          #DefundDeforestation Toolkit
        </h1>
        <p styleName='subtitle'>
          A How-To Guide to Deforestation Free 401(k)s
        </p>

        <div styleName='content-info'>
          <h2 styleName='answer-title'>
            How forest-friendly are your 401(k) fund choices?
          </h2>
          <p>
            Your 401(k) portfolio could be an engine for more positive impact. You can help move your employer-sponsored retirement plan to offer deforestation-free and sustainable funds, allowing you to invest your retirement to help build a greener, more just world.
          </p>
          <p>
            Deforestation and degradation of vast swaths of land for commodities such as palm oil, pulp and paper, cattle, soy, timber, and rubber is responsible for almost one quarter of all global greenhouse gas emissions and for unprecedented species extinction. Simultaneously, the occupation of vast areas of land for industrial plantation agriculture is a leading cause of violent land conflicts due to its frequent dispossession and displacement of local and indigenous communities.
          </p>
          <p>
            Simply put, if we want to limit the catastrophic impacts of climate change, reduce our impact on the world’s biodiversity, and respect the rights of indigenous peoples, protecting the world’s remaining forests is key.
          </p>
          <p>
            Deforestation isn’t just bad for the planet. Increasingly, it’s risky business. Companies engaged in deforestation, land grabbing and human rights violations expose themselves and their shareholders to significant financial risks from stalled business operations, reputational damage, and legal liabilities.
          </p>
          <p>
            The industries that drive most deforestation, especially in the tropics, are palm oil, paper/pulp, rubber, timber, cattle, and soy. If it were up to you, your money probably wouldn’t be invested in these industries. But would you know it if it was? 
          </p>
          <p>
            Your savings may be linked to deforestation directly, through investments in <b>agricultural commodity producers and traders</b> (companies that produce and trade palm oil, paper/pulp, rubber, timber, cattle, and soy); or indirectly, through investments in <b>banks</b> that underwrite and lend to deforestation-risk companies, or in <b>consumer goods retailers</b> that source palm oil, paper/pulp, rubber, timber, cattle, and soy from deforestation-risk producers and traders and sell it to consumers worldwide. 
          </p>
          <p>
            When you think about ensuring that your investments are “deforestation-free,” you will need to consider the question “how deforestation-free can we get?”
          </p>
          <p>
            For instance, after you look through DeforestationFreeFunds.org, you will see that it can be relatively easy to find funds that are not invested in the direct deforesters (the big agribusiness producers that may actively destroy forests), but it can be much more difficult to find funds that are not invested in the more commonly-held consumer goods companies and banks, which are more indirectly linked to deforestation. However, if funds are invested in the consumer goods companies and banks, fund managers, and you as a shareholder, can actively push these companies towards deforestation-free supply chains – so pulling your money from all three of the sectors linked to deforestation may not be the only way to support deforestation-free action.
          </p>

          <div styleName='cntr'>
            <Link
              to={config.routes.faq}
              title='Frequently Asked Questions | Deforestation Free Funds'
            >
              <div styleName='faq-btn'>
                Frequently asked questions<LinkIcon />
              </div>
            </Link>
          </div>

          <div styleName='cntr'>
            <Link
              to={infographicLarge}
              title='Palm oil is one of the agribusiness sectors drives massive deforestation across the tropics. This graphic could apply just as well to other “deforestation-risk commodities” such as cattle, soy, timber, paper and rubber.'
            >
              <img
                src={infographicSmall}
                alt='Palm oil is one of the agribusiness sectors drives massive deforestation across the tropics. This graphic could apply just as well to other “deforestation-risk commodities” such as cattle, soy, timber, paper and rubber.'
                styleName='infographic-small'
              />
            </Link>
          </div>
          <p>
            <em>Palm oil is one of the agribusiness sectors drives massive deforestation across the tropics. This graphic could apply just as well to other “deforestation-risk commodities” such as cattle, soy, timber, paper and rubber.</em>
          </p>
        </div>
        
        <h2 styleName='section-title'>
          If your investments are in your employer-sponsored plan
        </h2>
        <div styleName='content-info'>
          <p>
            If you don’t have an IRA or a personal investment that you control, one of the best ways to make sure you’re not invested in problematic forest-risk companies is to work with your employer to add one or more deforestation-free and socially responsible funds to the list of your employer-offered 401(k) options.
          </p>
          <p>
            You will need to engage the plan administrator, point them to the right list of funds, and make the case as to why offering such fund options is important. This may take time and possibly some coordination with your co-plan participants. We outline steps below that will help you work with employer to make this happen.
          </p>
        </div>

        <h3 styleName='answer-title'>
          1) Talk to your colleagues and build a coalition
        </h3>
        <div styleName='content-info'>
          <p>
            To effectively advocate for deforestation-free offerings through your employer-sponsored plan, first build a coalition of peers and interested co-workers inside your company. Your voice will be much stronger as a group. If you’re writing to someone in power, advocating on behalf of 10 or even 20 people carries a lot more weight than just one. One way to spur interest would be sharing results from Deforestation Free Funds with fellow employees. This can be done using social media available on each page of the site. All plan participants are offered the same basket of mutual funds as you are, so they are probably asking the same questions right now. It will certainly make interesting conversation over the water-cooler.
          </p>
          <p>
            Some companies have “green teams,” or there may be other employee sponsored affinity groups you could approach. If there isn’t one already, it may be time to create one that can address deforestation. Communicate with your co-workers through a company intranet, employee portal, a company newsletter, corporate chats, or social media. The herd is heard! So, create a petition or letter to the HR manager, the CEO, or your company’s 401(k) manager as a first step. Also, engage those employees most interested in supporting this quest to be allies who will call or write individually, at crucial points in the process, as you move forward.
          </p>
        </div>

        <h3 styleName='answer-title'>
          2) Identify the best people in the company to speak with
        </h3>
        <div styleName='content-info'>
          <p>
            The 401(k)/403(b) plan administrator, manager, or coordinator should be known to you if you are a plan participant. This is the person that will ultimately have to agree to make the requested change. But, to make sure you have the best chance of success when approaching such managers, in addition to building a coalition of supportive employees, consider building a coalition of support, or a few key allies, within the company. Your company might have a chief sustainability officer or employee engagement manager, which could be good resources in supporting your effort. One effective place to start building allies is to go to LinkedIn pages and find those persons who might have some sympathy for the cause. Do any of them volunteer or have connections with organizations concerned with climate change? Look for indicators that they’re friendly to sustainability and start contacting them in order of their friendliness. In a publicly listed company with more structure, a coalition is vital to signal to managers that it’s an important issue for many employees. If it’s a smaller company, the CFO or CEO could be approached directly. In a mid-size or family company, a family member could be more influential.
          </p>
        </div>

        <h3 styleName='answer-title'>
          3) Bring a solution to the table
        </h3>
        <div styleName='content-info'>
          <p>
            The usual starting point in these conversations is: “We want to avoid investing in companies that contribute to deforestation. We also want to reduce the future risk of our 401(k) fund choices. Adding funds to our 401(k) choices that are rated as both deforestation-free and socially responsible on the Deforestation Free Funds tool is an easy way to do so.”
          </p>
          <p>
            Note that getting three fund choices added to the existing 15-30 is a formal process, and could take up to a year. Larger companies often have some form of investment committee, which engages an investment advisor.
          </p>
          <p>
            If the investment advisor and plan administrator refuse to help in swapping out funds invested in deforestation-linked agribusiness companies (or fossil fuels, for that matter), you may need to pull out your employee petition, or organize letters or calls from your management supporters to the investment committee. If you are told, “But you’ll make less money if you’re too focused on environmental issues like deforestation,” you can say, “Actually, investing in companies that destroy forests and cause social conflicts is a risky bet, both for the planet and for the long term health of my portfolio. In fact, the Department of Labor recently affirmed that environmental and social factors may have a direct impact on the value of an investment, and can be considered as part of a 401(k) administrator’s fiduciary duty.”
          </p>
        </div>

        <h3 styleName='answer-title-spaceabove'>
          Sample petition letter to Retirement Plan manager
        </h3>
        <div styleName='content-info'>
          <div styleName='letter-boxquote'>
            <p>
              Dear Plan Administrator,
            </p>
            <p>
              I am an employee of <b>[Company Name]</b>, and I participate in our company 401(k) plan. I am writing to raise concerns about tropical deforestation and human rights abuses that may be supported by our current investment policy and about my desire to have options for socially responsible funds.
            </p>
            <p>
              Deforestation is a major driver of climate change, biodiversity loss, and attacks on indigenous communities across the tropics. Conversely, maintaining healthy, intact ecosystems is the best prevention we have against both runaway climate change and future pandemics. As the environmental and social effects of deforestation become more widely recognized, investments in the agribusiness companies behind the problem are becoming increasingly risky.
            </p>
            <p>
              I [and the attached list of employees] would like to be able to invest in a fund that does not harm forests for purposes of agro-commodity production or sales. Through use of an online tool at <Link to={config.routes.home} title='Deforestation Free Funds' xstrong>
              deforestationfreefunds.org</Link> I was able to analyze many commonly available mutual funds and identify ones that earn a top score regarding deforestation. Importantly, this tool also provides information on funds that are also socially responsible. I note that none of the funds offered in our 401(k) fund are currently forest-safe and socially responsible. In addition to being deforestation-free, I [we] seek a fund that is socially responsible. Socially responsible investing is no longer just an ethical issue, it is a key factor in reducing investment risk and impacting financial well-being. New guidelines from the Department of Labor state that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be used when making decisions related to fiduciary duty.
            </p>
            <p>
              Since none of our current plan options are both socially responsible and earn a top rating as deforestation-free, I request that our 401(k) fund plan begin offering one or more such funds in which interested employees can invest. The <Link to={config.routes.home} title='Deforestation Free Funds' xstrong>deforestationfreefunds.org</Link> tool is a good option for finding suitable mutual funds that could be included in our plan.
            </p>
            <p>
              Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you.
            </p>
            <p>
              Best,
            </p>
            <p>
              <b>[Your Name]</b>
            </p>
            <p>
              <b>[Your contact information (company department, email, phone)]</b>
            </p>
            <p>
              <b>[Attachment: Employee/manager letter of support]</b>
            </p>
          </div>
          <CopyToClipboard
            onCopy={this.onCopy}
            text={this.state.value}>
            <button
              styleName='letter-boxquote-copy-button'>
              {
                this.state.copied ?
                null :
                (
                  <span><i className='fa fa-files-o'/>&nbsp;&nbsp;&nbsp;</span>
                )
              }
              {
                this.state.copied ?
                  'Copied!' :
                  'Copy to clipboard'
              } 
            </button>
          </CopyToClipboard>
        </div>

        <h2 styleName='section-title'>
          If you’re an individual investor
        </h2>
        <div styleName='content-info'>
          <p>
            For indiviual investors, it is simpler to reinvest the investments you have in companies that are linked to deforestation. You can trade your own portfolio, or tell your manager to do it. It’s your money, and your financial advisor works for you. You just need to have a meeting to discuss what you have learned about your holdings and how you would like your holdings changed to align with your values. An investment professional will advise you of potential risk and you can make your decisions.
          </p>
          <p>
            They may push back and tell you that you’ll make less money. Again, you can reply, “Maybe, but it’s my money, I want less risk, and if agribusiness is not deforestation-free, then its risky business – look at fossil fuels and conflict diamonds.” Your financial advisor wants, and it’s their job, to make you money, so you should drive home the point in no uncertain terms. You should also let them know that their fiduciary duty to you includes consideration of your appetite for environmental and social risk. Ask for help finding the best choices. The advisor may say no if you tell them to invest in a specific fund because it has a short or rocky history, so you may need to be patient as they find a better alternative. The goal is to focus on and remove the risk, especially future risk, as well as returns, not a specific fund. If your manager is being lazy or unwilling to help you with this transition, find a new advisor. If your broker is tied to a big-name brand, they may only be able to offer products that the particular company has approved. If you want innovation, you might need a new advisor.
          </p>
        </div>
      </ContainerDivs>

      <br/>
      <br/>
      <br/>
      <br/>

      <GetStartedInput />

      <ContainerDivs>
        <AboutBanner />
      </ContainerDivs>

    </div>
  }
}
